import { CALL_ORIGIN_TARGETED_OFFERS } from 'contexts/CruiseSearchContext/constants';

export const getInputLoadTargetedOffers = ({
  queryLoyalty,
  queryEmail,
  cookieLoyalty,
  cookieEmail,
}) => {
  if (queryLoyalty || queryEmail) {
    const hadLoyalty = !!queryLoyalty;
    const hadEmail = !!queryEmail;
    return {
      email: null,
      loyaltyID: hadLoyalty && queryLoyalty,
      originLoyalty: hadLoyalty && CALL_ORIGIN_TARGETED_OFFERS.URL,
      emailEncrypt: hadEmail && queryEmail,
      originEmail: hadEmail && CALL_ORIGIN_TARGETED_OFFERS.URL,
      originCall: CALL_ORIGIN_TARGETED_OFFERS.URL,
    };
  }

  if (cookieLoyalty || cookieEmail) {
    const hadLoyalty = !!cookieLoyalty;
    const hadEmail = !!cookieEmail;
    return {
      email: null,
      loyaltyID: hadLoyalty && cookieLoyalty,
      originLoyalty: hadLoyalty && CALL_ORIGIN_TARGETED_OFFERS.COOKIE,
      emailEncrypt: hadEmail && cookieEmail,
      originEmail: hadEmail && CALL_ORIGIN_TARGETED_OFFERS.COOKIE,
      originCall: CALL_ORIGIN_TARGETED_OFFERS.COOKIE,
    };
  }
};
